import script from "./EventPageAbsencesListAll.vue?vue&type=script&setup=true&lang=js"
export * from "./EventPageAbsencesListAll.vue?vue&type=script&setup=true&lang=js"

import "./EventPageAbsencesListAll.vue?vue&type=style&index=0&id=8e48f410&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e48f410"]])

export default __exports__